var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 191.5L6.5 190.5L5.5 186L4.5 190.5L0 191.5L4.5 192.5L5.5 197L6.5 192.5L11 191.5Z",
    fill: "#0B225C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 222.5L6.5 221.5L5.5 217L4.5 221.5L0 222.5L4.5 223.5L5.5 228L6.5 223.5L11 222.5Z",
    fill: "#0B225C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 191.5L37.5 190.5L36.5 186L35.5 190.5L31 191.5L35.5 192.5L36.5 197L37.5 192.5L42 191.5Z",
    fill: "#0B225C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 222.5L37.5 221.5L36.5 217L35.5 221.5L31 222.5L35.5 223.5L36.5 228L37.5 223.5L42 222.5Z",
    fill: "#0B225C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73 191.5L68.5 190.5L67.5 186L66.5 190.5L62 191.5L66.5 192.5L67.5 197L68.5 192.5L73 191.5Z",
    fill: "#0B225C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73 222.5L68.5 221.5L67.5 217L66.5 221.5L62 222.5L66.5 223.5L67.5 228L68.5 223.5L73 222.5Z",
    fill: "#0B225C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104 191.5L99.5 190.5L98.5 186L97.5 190.5L93 191.5L97.5 192.5L98.5 197L99.5 192.5L104 191.5Z",
    fill: "#0B225C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104 222.5L99.5 221.5L98.5 217L97.5 221.5L93 222.5L97.5 223.5L98.5 228L99.5 223.5L104 222.5Z",
    fill: "#0B225C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135 191.5L130.5 190.5L129.5 186L128.5 190.5L124 191.5L128.5 192.5L129.5 197L130.5 192.5L135 191.5Z",
    fill: "#0B225C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135 222.5L130.5 221.5L129.5 217L128.5 221.5L124 222.5L128.5 223.5L129.5 228L130.5 223.5L135 222.5Z",
    fill: "#0B225C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197 191.5L192.5 190.5L191.5 186L190.5 190.5L186 191.5L190.5 192.5L191.5 197L192.5 192.5L197 191.5Z",
    fill: "#0B225C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197 222.5L192.5 221.5L191.5 217L190.5 221.5L186 222.5L190.5 223.5L191.5 228L192.5 223.5L197 222.5Z",
    fill: "#0B225C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166 191.5L161.5 190.5L160.5 186L159.5 190.5L155 191.5L159.5 192.5L160.5 197L161.5 192.5L166 191.5Z",
    fill: "#0B225C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166 222.5L161.5 221.5L160.5 217L159.5 221.5L155 222.5L159.5 223.5L160.5 228L161.5 223.5L166 222.5Z",
    fill: "#0B225C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228 191.5L223.5 190.5L222.5 186L221.5 190.5L217 191.5L221.5 192.5L222.5 197L223.5 192.5L228 191.5Z",
    fill: "#0B225C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M228 222.5L223.5 221.5L222.5 217L221.5 221.5L217 222.5L221.5 223.5L222.5 228L223.5 223.5L228 222.5Z",
    fill: "#0B225C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11 160.5L6.5 159.5L5.5 155L4.5 159.5L0 160.5L4.5 161.5L5.5 166L6.5 161.5L11 160.5Z",
    fill: "#0B225C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42 160.5L37.5 159.5L36.5 155L35.5 159.5L31 160.5L35.5 161.5L36.5 166L37.5 161.5L42 160.5Z",
    fill: "#0B225C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73 160.5L68.5 159.5L67.5 155L66.5 159.5L62 160.5L66.5 161.5L67.5 166L68.5 161.5L73 160.5Z",
    fill: "#0B225C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104 160.5L99.5 159.5L98.5 155L97.5 159.5L93 160.5L97.5 161.5L98.5 166L99.5 161.5L104 160.5Z",
    fill: "#0B225C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135 160.5L130.5 159.5L129.5 155L128.5 159.5L124 160.5L128.5 161.5L129.5 166L130.5 161.5L135 160.5Z",
    fill: "#0B225C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M197 160.5L192.5 159.5L191.5 155L190.5 159.5L186 160.5L190.5 161.5L191.5 166L192.5 161.5L197 160.5Z",
    fill: "#0B225C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M166 160.5L161.5 159.5L160.5 155L159.5 159.5L155 160.5L159.5 161.5L160.5 166L161.5 161.5L166 160.5Z",
    fill: "#0B225C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M228 160.5L223.5 159.5L222.5 155L221.5 159.5L217 160.5L221.5 161.5L222.5 166L223.5 161.5L228 160.5Z",
    fill: "#0B225C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11 129.5L6.5 128.5L5.5 124L4.5 128.5L0 129.5L4.5 130.5L5.5 135L6.5 130.5L11 129.5Z",
    fill: "#0B225C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42 129.5L37.5 128.5L36.5 124L35.5 128.5L31 129.5L35.5 130.5L36.5 135L37.5 130.5L42 129.5Z",
    fill: "#0B225C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M73 129.5L68.5 128.5L67.5 124L66.5 128.5L62 129.5L66.5 130.5L67.5 135L68.5 130.5L73 129.5Z",
    fill: "#0B225C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104 129.5L99.5 128.5L98.5 124L97.5 128.5L93 129.5L97.5 130.5L98.5 135L99.5 130.5L104 129.5Z",
    fill: "#0B225C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M135 129.5L130.5 128.5L129.5 124L128.5 128.5L124 129.5L128.5 130.5L129.5 135L130.5 130.5L135 129.5Z",
    fill: "#0B225C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M197 129.5L192.5 128.5L191.5 124L190.5 128.5L186 129.5L190.5 130.5L191.5 135L192.5 130.5L197 129.5Z",
    fill: "#0B225C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166 129.5L161.5 128.5L160.5 124L159.5 128.5L155 129.5L159.5 130.5L160.5 135L161.5 130.5L166 129.5Z",
    fill: "#0B225C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M228 129.5L223.5 128.5L222.5 124L221.5 128.5L217 129.5L221.5 130.5L222.5 135L223.5 130.5L228 129.5Z",
    fill: "#0B225C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11 98.5L6.5 97.5L5.5 93L4.5 97.5L0 98.5L4.5 99.5L5.5 104L6.5 99.5L11 98.5Z",
    fill: "#0B225C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42 98.5L37.5 97.5L36.5 93L35.5 97.5L31 98.5L35.5 99.5L36.5 104L37.5 99.5L42 98.5Z",
    fill: "#0B225C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98.5L68.5 97.5L67.5 93L66.5 97.5L62 98.5L66.5 99.5L67.5 104L68.5 99.5L73 98.5Z",
    fill: "#0B225C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104 98.5L99.5 97.5L98.5 93L97.5 97.5L93 98.5L97.5 99.5L98.5 104L99.5 99.5L104 98.5Z",
    fill: "#0B225C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135 98.5L130.5 97.5L129.5 93L128.5 97.5L124 98.5L128.5 99.5L129.5 104L130.5 99.5L135 98.5Z",
    fill: "#0B225C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M197 98.5L192.5 97.5L191.5 93L190.5 97.5L186 98.5L190.5 99.5L191.5 104L192.5 99.5L197 98.5Z",
    fill: "#0B225C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M166 98.5L161.5 97.5L160.5 93L159.5 97.5L155 98.5L159.5 99.5L160.5 104L161.5 99.5L166 98.5Z",
    fill: "#0B225C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M228 98.5L223.5 97.5L222.5 93L221.5 97.5L217 98.5L221.5 99.5L222.5 104L223.5 99.5L228 98.5Z",
    fill: "#0B225C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11 67.5L6.5 66.5L5.5 62L4.5 66.5L0 67.5L4.5 68.5L5.5 73L6.5 68.5L11 67.5Z",
    fill: "#0B225C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67.5L37.5 66.5L36.5 62L35.5 66.5L31 67.5L35.5 68.5L36.5 73L37.5 68.5L42 67.5Z",
    fill: "#0B225C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67.5L68.5 66.5L67.5 62L66.5 66.5L62 67.5L66.5 68.5L67.5 73L68.5 68.5L73 67.5Z",
    fill: "#0B225C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67.5L99.5 66.5L98.5 62L97.5 66.5L93 67.5L97.5 68.5L98.5 73L99.5 68.5L104 67.5Z",
    fill: "#0B225C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M135 67.5L130.5 66.5L129.5 62L128.5 66.5L124 67.5L128.5 68.5L129.5 73L130.5 68.5L135 67.5Z",
    fill: "#0B225C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M197 67.5L192.5 66.5L191.5 62L190.5 66.5L186 67.5L190.5 68.5L191.5 73L192.5 68.5L197 67.5Z",
    fill: "#0B225C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M166 67.5L161.5 66.5L160.5 62L159.5 66.5L155 67.5L159.5 68.5L160.5 73L161.5 68.5L166 67.5Z",
    fill: "#0B225C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M228 67.5L223.5 66.5L222.5 62L221.5 66.5L217 67.5L221.5 68.5L222.5 73L223.5 68.5L228 67.5Z",
    fill: "#0B225C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11 36.5L6.5 35.5L5.5 31L4.5 35.5L0 36.5L4.5 37.5L5.5 42L6.5 37.5L11 36.5Z",
    fill: "#0B225C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36.5L37.5 35.5L36.5 31L35.5 35.5L31 36.5L35.5 37.5L36.5 42L37.5 37.5L42 36.5Z",
    fill: "#0B225C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36.5L68.5 35.5L67.5 31L66.5 35.5L62 36.5L66.5 37.5L67.5 42L68.5 37.5L73 36.5Z",
    fill: "#0B225C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M104 36.5L99.5 35.5L98.5 31L97.5 35.5L93 36.5L97.5 37.5L98.5 42L99.5 37.5L104 36.5Z",
    fill: "#0B225C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M135 36.5L130.5 35.5L129.5 31L128.5 35.5L124 36.5L128.5 37.5L129.5 42L130.5 37.5L135 36.5Z",
    fill: "#0B225C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M197 36.5L192.5 35.5L191.5 31L190.5 35.5L186 36.5L190.5 37.5L191.5 42L192.5 37.5L197 36.5Z",
    fill: "#0B225C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M166 36.5L161.5 35.5L160.5 31L159.5 35.5L155 36.5L159.5 37.5L160.5 42L161.5 37.5L166 36.5Z",
    fill: "#0B225C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M228 36.5L223.5 35.5L222.5 31L221.5 35.5L217 36.5L221.5 37.5L222.5 42L223.5 37.5L228 36.5Z",
    fill: "#0B225C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5L6.5 4.5L5.5 0L4.5 4.5L0 5.5L4.5 6.5L5.5 11L6.5 6.5L11 5.5Z",
    fill: "#0B225C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M42 5.5L37.5 4.5L36.5 0L35.5 4.5L31 5.5L35.5 6.5L36.5 11L37.5 6.5L42 5.5Z",
    fill: "#0B225C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M73 5.5L68.5 4.5L67.5 0L66.5 4.5L62 5.5L66.5 6.5L67.5 11L68.5 6.5L73 5.5Z",
    fill: "#0B225C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M104 5.5L99.5 4.5L98.5 0L97.5 4.5L93 5.5L97.5 6.5L98.5 11L99.5 6.5L104 5.5Z",
    fill: "#0B225C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M135 5.5L130.5 4.5L129.5 0L128.5 4.5L124 5.5L128.5 6.5L129.5 11L130.5 6.5L135 5.5Z",
    fill: "#0B225C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M197 5.5L192.5 4.5L191.5 0L190.5 4.5L186 5.5L190.5 6.5L191.5 11L192.5 6.5L197 5.5Z",
    fill: "#0B225C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M166 5.5L161.5 4.5L160.5 0L159.5 4.5L155 5.5L159.5 6.5L160.5 11L161.5 6.5L166 5.5Z",
    fill: "#0B225C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M228 5.5L223.5 4.5L222.5 0L221.5 4.5L217 5.5L221.5 6.5L222.5 11L223.5 6.5L228 5.5Z",
    fill: "#0B225C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparks);
export default __webpack_public_path__ + "static/media/Sparks.8e412d94da7812b597904d2bb149bce7.svg";
export { ForwardRef as ReactComponent };